import { Component, OnInit, inject } from '@angular/core';
import { SsoRedirectorService } from '../../services/sso-redirector.service';
import { HELIOS_SSO } from 'src/app/tokens';
import { NavigationExtras, Router } from '@angular/router';
import { HeliosSsoAuthService } from '../../services/helios-sso-auth.service';

@Component({
  selector: 'app-helios-sso',
  templateUrl: './helios-sso.component.html',
  styleUrls: ['./helios-sso.component.scss']
})
export class HeliosSsoComponent implements OnInit {
  ssoRedirector = inject(SsoRedirectorService);
  heliosConfig = inject(HELIOS_SSO);
  heliosSsoAuthService = inject(HeliosSsoAuthService);
  canAccessHeliosSso = false;
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.hasHeliosAccess();
  }

  heliosSSO() {
    this.ssoRedirector.ssoSamlOutBound(
      this.heliosConfig.idpUrl,
      this.heliosConfig.serviceUrl,
      this.heliosConfig.issuer
    );
  }

  hasHeliosAccess() {
    this.heliosSsoAuthService.getHeliosRoles().subscribe((res: any) => {
      this.canAccessHeliosSso = res.roles.includes('CanAccessHeliosSso');
      if (this.canAccessHeliosSso) {
        setTimeout(() => {
          this.heliosSSO();
          this.router.navigate(['/']);
        }, 3000);
      } else {
        const navigationParams: NavigationExtras = {
          queryParams: { member: 'Unauthorized', pageName: 'access Helios' }
        };
        this.router.navigate(['/unauthorized'], navigationParams);
      }
      (error) => error;
    });
  }
}
